export default __webpack_public_path__ + "static/media/0255.28451b53.jpg";